<template>
  <div class="alert-secondary mb-3">
      <b-row>
          <b-col>
              <b-input-group>
                  <template #prepend>
                    <b-form-select v-model="inputType" :options="options" size="md"></b-form-select>
                  </template>

                  <b-form-input type="search" v-model="inputValue" v-on:keyup.enter="search()"></b-form-input>

                  <b-input-group-append>
                      <b-button variant="primary" @click="search()">Search</b-button>
                  </b-input-group-append>
              </b-input-group>
          </b-col>
      </b-row>   
  </div>
</template>

<script>
  import platformOptions from "../../assets/platformOptions";
  import locationOptions from "../../assets/locationOptions";
  import ShippingOptionsMixin from "../../assets/shippingOptions";
  import countryList from "../../assets/countryList";

  export default {
      name: "CustomerSearch",
      props: [ "searchQuery" ],
      mixins: [ platformOptions, locationOptions, ShippingOptionsMixin, countryList ],
      mounted() {
        if (this.searchQuery && this.searchQuery.query) {
          if (this.searchQuery.query.length) {
            this.inputType = 'query';
            this.inputValue = this.searchQuery.query;
          }
        }
      },
      data() {
          return {
              showFilters: false,
              inputValue: '',
              inputType: 'query',
              options: [{ value: null, text: 'Search by...', disabled: true},
                { value: 'query', text: 'Name / Email / ID' },
                { value: 'platformId', text: 'Platform ID' },
                { value: 'orderId', text: 'Order ID'},
                { value: 'address', text: 'Address' },
                { value: 'phoneNumber', text: 'Phone'},
              ]
            }
      },
      methods: {
          search() {
            let searchObject;
            if (this.inputType === "query") {
                searchObject = { query: this.inputValue, filters: {} };
            } else {
                searchObject = { query: null, filters: { [this.inputType]: this.inputValue } };
            }
            this.$emit('search', searchObject);
          },
      },
  }
</script>

<style scoped>
  .shipInputs {
      width: 50%;
  }
</style>